import { Badge, Card, Col, Drawer, Row, Space, Typography } from "antd";
import ProblemSuggestionForm from "./Components/ProblemSuggestionForm ";
import { useGetFeedbacksByUser } from "./ServerSideStates";
import { useState } from "react";
import { MazakaButton } from "apps/Common/MazakaButton";
import { PlusOutlined } from "@ant-design/icons";
import endPoints from "./EndPoints";
import { useQueryClient } from "react-query";
import ListItems from "./ListItems";
import PageTitle from "apps/Common/PageTitle";
import { Helmet } from "react-helmet-async";
import StaticPageBanner from "apps/Common/StaticPageBanner";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/Reducers";
import { Link } from "react-router-dom";

const ProblemsSuggestionIndex = () => {
    const { userInfoes } = useSelector((state: RootState) => state.profile);
  const queryClient = useQueryClient();
  const feedbacks = useGetFeedbacksByUser();
  const [isShowAddFeedbackDrawer, setIsShowFeedbackDrawer] = useState(false);
  const { Text } = Typography;

  if (!userInfoes) {
    return (
      <Col xs={24}>
        <Row gutter={[0, 20]}>
          <Col xs={24}>
            <StaticPageBanner 
              title={"Soru ve Öneriler"}
              description={"Soru ve Önerilerinizi Bize Bildiriniz."}
            />
          </Col>
          <Col xs={24} className="text-center p-8">
            <Card>
              <Text className="text-lg">
                Soru ve öneri eklemek için lütfen  giriş yapınız.
              </Text>
            </Card>
          </Col>
        </Row>
      </Col>
    );
  }

  return (
    <>
      <Helmet>
        <title className="capitalize">{"Soru ve Öneriler"}</title>
      </Helmet>
      
      <Col xs={24}>
        <Row gutter={[0, 20]}>
          {/* Banner Section */}
          <Col xs={24}>
            <div className="w-full">
              <StaticPageBanner 
                title={`Soru ve Öneriler (${feedbacks?.data?.data?.length || 0})`}
                description={"Soru ve Önerilerinizi Bize Bildiriniz."}
              />
            </div>
          </Col>
          
          {/* Add Button Section */}
          <Col xs={24}>
            <div className="flex justify-end px-4 sm:px-6 lg:px-8">
              <MazakaButton
                className="bg-black text-white text-xs sm:text-sm px-3 py-2 sm:px-4 sm:py-3 flex items-center gap-2 rounded-md hover:bg-gray-800 transition-colors"
                icon={<PlusOutlined />}
                onClick={() => {
                  setIsShowFeedbackDrawer(true);
                }}
              >
                <span className="hidden sm:inline">Sorun ve Önerileri Ekle</span>
                <span className="sm:hidden">Ekle</span>
              </MazakaButton>
            </div>
          </Col>
          
          {/* List Items Section */}
          <Col xs={24}>
            <div className="px-4 sm:px-6 lg:px-8">
              <ListItems />
            </div>
          </Col>
        </Row>
      </Col>
      
      {/* Drawer */}
      <Drawer
        title="Yeni Soru/Öneri Ekle"
        placement="right"
        width="20%"
        styles={{
          body: { padding: '16px' }
        }}
        className="[&_.ant-drawer-content-wrapper]:!w-full sm:[&_.ant-drawer-content-wrapper]:!w-[480px] lg:[&_.ant-drawer-content-wrapper]:!w-[600px]"
        open={isShowAddFeedbackDrawer}
        onClose={() => {
          setIsShowFeedbackDrawer(false);
        }}
      >
        <ProblemSuggestionForm
          onFinish={() => {
            setIsShowFeedbackDrawer(false);
            queryClient.resetQueries({
              queryKey: endPoints.getFeedbackListByUser,
              exact: false,
            });
          }}
        />
      </Drawer>
    </>
  );
};

export default ProblemsSuggestionIndex;